import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Search, MessageCircle, GlassWater } from 'lucide-react';
const steps = [{
  icon: Search,
  title: 'Browse Profiles',
  desc: 'Explore our curated selection of premium companions.'
}, {
  icon: MessageCircle,
  title: 'Contact Directly',
  desc: 'Connect via WhatsApp or Telegram to arrange your date.'
}, {
  icon: GlassWater,
  title: 'Enjoy Experience',
  desc: 'Meet your companion and enjoy a memorable time.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-[#0a0a0a] border-y border-[#c9a96e]/10" data-id="element-154">
      <div className="max-w-7xl mx-auto px-6" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-157">
            How It Works <span className="text-[#c9a96e]" data-id="element-158">如何预约</span>
          </h2>
          <p className="text-neutral-400 max-w-xl mx-auto" data-id="element-159">
            Simple, discreet, and secure booking process designed for your
            convenience.
          </p>
        </motion.div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-160">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-gradient-to-r from-transparent via-[#c9a96e]/30 to-transparent" data-id="element-161" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center z-10" data-id="element-162">
              <div className="w-24 h-24 rounded-full bg-[#111111] border border-[#c9a96e]/30 flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(0,0,0,0.5)] group hover:border-[#c9a96e] transition-colors duration-500" data-id="element-163">
                <step.icon className="text-[#c9a96e] group-hover:scale-110 transition-transform duration-500" size={32} data-id="element-164" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#c9a96e] text-black font-bold flex items-center justify-center text-sm" data-id="element-165">
                  {index + 1}
                </div>
              </div>

              <h3 className="text-xl font-serif text-white mb-3" data-id="element-166">
                {step.title}
              </h3>
              <p className="text-neutral-400 text-sm leading-relaxed max-w-xs" data-id="element-167">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}